import React from 'react'
import './footer.css'
import Images from "../../data/Images";

const Footer = () => {
  return (
    <div className='footer'>
      <div className="footer1">
        <div data-aos="fade-up" className="f-icon">
            <img src={Images.logo} alt="logo" />
        </div>
        <div className="f-list">
        <a data-aos="fade-up" href="about" className="link">
          About
        </a>
        <a data-aos="fade-up" href="#service" className="link">
          Services
        </a>
        <a data-aos="fade-up" href="#projects" className="link">
          Projects
        </a>
        <a data-aos="fade-up" href="#contact" className="link">
          Contact
        </a>
        </div>
        <div className="f-list">
        <a data-aos="fade-up" href="https://www.instagram.com/codingeggs/" className="link">
          Instagram
        </a>
        <a data-aos="fade-up" href="https://github.com/Dhruvasth" className="link">
          Github
        </a>
        <a data-aos="fade-up" href="https://twitter.com/codingeggs" className="link">
          Twitter
        </a>
        <a data-aos="fade-up" href="https://dribbble.com/Dhruvasth" className="link">
          Dribble
        </a>
        <a data-aos="fade-up" href="https://www.behance.net/dhruvasth" className="link">
          Behance
        </a>
        <a data-aos="fade-up" href="https://www.linkedin.com/in/dhruv-asth/" className="link">
          Linkedin
        </a>
        </div>
        </div>

        <div className="footer3">
        <div className="s-line"></div>
        </div>

        <div className="footer2">
          <div  className="f-name">
            ©2022, DHRUV ASTH
          </div>
        <div  className="top">
        <a href='#'>
          <img href="https://github.com/Dhruvasth" src={Images.Top} alt="top" /> Back To Top
          </a>
        </div>
        </div>
    </div>
  )
}

export default Footer